// Which ways of creating accounts are switched on. Creating an account emails
// a temporary password, which the backend can send now (RESEND_API_KEY is set
// on staging and prod).

// Admins add nurses from the Nurses page.
export const ADMIN_NURSE_CREATION_ENABLED = true;

// Charge nurses add nurses to their own unit from the Nurse Console.
export const CHARGE_NURSE_CREATION_ENABLED = true;

// Adding admins on the Admins page stays off for now.
export const ADMIN_CREATION_ENABLED = false;
